document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.size-guide-section');
  sections.forEach(section => initSizeGuide(section));

  function initSizeGuide(root) {
    const productItems = [...root.querySelectorAll('.sg-product-item')];
    const genderTabs = [...root.querySelectorAll('.gender-tab')];
    const unitButtons = [...root.querySelectorAll('.unit-btn')];
    const unitToggle = document.querySelector(".unit-toggle");
    unitButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        unitButtons.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        if (btn.textContent.trim().toLowerCase() === "cms") {
          unitToggle.classList.add("cms-active");
        } else {
          unitToggle.classList.remove("cms-active");
        }
      });
    });
    const measurementImgContainer = root.querySelector('#sg-measurement-img');
    const chartContainer = root.querySelector('#sg-sizecharts');
    const cardsArea = root.querySelector('#sg-cards-area');
    const exploreWrapper = root.querySelector('#sg-explore-wrapper');
    const measureTextEl = root.querySelector('#sg-measure-text');

    let activeIndex = 0;
    let activeGender = 'men';
    let activeUnit = 'in';
    let previewIndex = null;

    if (!productItems.length) return;

    function getCurrentIndex() {
      return previewIndex != null ? previewIndex : activeIndex;
    }

    function updateTabs() {
      productItems.forEach((item, i) => {
        item.classList.toggle('active', i === activeIndex);
        item.classList.toggle(
          'hover-preview',
          previewIndex === i && previewIndex !== activeIndex
        );
      });
    }

    function selectProduct(i, lock = true) {
      function preload(src) {
  if (!src) return;
  const img = new Image();
  img.src = src;
}

function preloadAll(btn) {
  const d = btn.dataset;
  [
    d.measure_men, d.measure_women, d.measure_youth,
    d.chart_men_in, d.chart_men_cm,
    d.chart_women_in, d.chart_women_cm,
    d.chart_youth_in, d.chart_youth_cm
  ].forEach(preload);
}
      if (lock) {
        activeIndex = i;
        previewIndex = null;
      } else {
        previewIndex = i;
      }
      const btn = productItems[i].querySelector('.sg-product-btn');
  preloadAll(btn);
  
      updateTabs();
      updateContent();
    }

    function clearPreview() {
      previewIndex = null;
      updateTabs();
      updateContent();
    }

    function selectGender(gender) {
      activeGender = gender;
      genderTabs.forEach(btn => {
        btn.classList.toggle('active', btn.dataset.gender === gender);
      });
      updateContent();
    }

    function selectUnit(unit) {
      activeUnit = unit;
      unitButtons.forEach(btn => {
        btn.classList.toggle('active', btn.dataset.unit === unit);
      });
      updateContent();
    }

    function updateContent() {
      const i = getCurrentIndex();
      const btn = productItems[i].querySelector('.sg-product-btn');
      if (!btn) return;

      const data = btn.dataset;
      const titleEl = document.getElementById("sg-dynamic-title");

      const heading = data.main_heading || data.title; // fallback
      const alignment = data.title_alignment || "center";

      titleEl.textContent = heading;
      titleEl.className = `sg-main-title sg-title-${alignment}`;
      const measureImg = data[`measure_${activeGender}`];
      const chartImg = data[`chart_${activeGender}_${activeUnit}`];
      const measureText = data.measure_text;

      measurementImgContainer.innerHTML = measureImg
        ? `<img src="${measureImg}" loading="lazy" alt="">`
        : `<div>No measurement image</div>`;

      chartContainer.innerHTML = chartImg
        ? `<img src="${chartImg}" loading="lazy" alt="">`
        : `<div>No size chart</div>`;

      measureTextEl.innerHTML =
        measureText && measureText.trim() !== "" && measureText !== "<p></p>"
          ? measureText
          : "";

      // Cards List
      const cards = [
        data.cardMen,
        data.cardWomen,
        data.cardYouth,
      ].filter(Boolean);

      cardsArea.innerHTML = cards
        .map(img => `<div class="sg-card"><img src="${img}" loading="lazy" alt=""></div>`)
        .join('');

      // Explore button
      if (data.exploreUrl) {
        exploreWrapper.innerHTML = `
      <a href="${data.exploreUrl}" class="sg-explore-btn">
        Explore ${data.title} →
      </a>`;
      } else {
        exploreWrapper.innerHTML = '';
      }

      // Pagination Dots
      createPaginationDots(cards.length);
    }

    function createPaginationDots(count) {
      let dotsWrapper = document.querySelector('.sg-dots');
      if (!dotsWrapper) {
        dotsWrapper = document.createElement('div');
        dotsWrapper.className = 'sg-dots';
        cardsArea.parentNode.appendChild(dotsWrapper);
      }

      dotsWrapper.innerHTML = "";
      for (let i = 0; i < count; i++) {
        dotsWrapper.innerHTML += `<span class="sg-dot"></span>`;
      }

      const dots = dotsWrapper.querySelectorAll('.sg-dot');

      function updateDotPosition() {
        const scrollPos = cardsArea.scrollLeft;
        const width = cardsArea.offsetWidth;
        const activeIndex = Math.round(scrollPos / width);
        dots.forEach((dot, i) =>
          dot.classList.toggle('active', i === activeIndex)
        );
      }

      updateDotPosition();
      cardsArea.addEventListener("scroll", updateDotPosition);
    }

    // Attach events
    productItems.forEach((li, i) => {
      const btn = li.querySelector('.sg-product-btn');
      if (!btn) return;

      btn.addEventListener('click', () => selectProduct(i, true));

      btn.addEventListener('mouseenter', () => {
        if (window.innerWidth > 992) selectProduct(i, false);
      });

      btn.addEventListener('mouseleave', () => {
        if (window.innerWidth > 992) clearPreview();
      });
    });

    genderTabs.forEach(btn => {
      btn.addEventListener('click', () => selectGender(btn.dataset.gender));
    });

    unitButtons.forEach(btn => {
      btn.addEventListener('click', () => selectUnit(btn.dataset.unit));
    });

    // Default state
    productItems[0].classList.add('active');
    selectProduct(0, true);
    selectGender('men');
    selectUnit('in');
  }
});
